import { jsx, Fragment } from "react/jsx-runtime";
import { Node_Type } from "@wix/ricos";
const htmlAttributesPlugin = (_) => ({
  config: {},
  type: "",
  nodeViewDecorators: [htmlAttributesDecorator],
  nodeViewRenderers: {
    [Node_Type.EXTERNAL]: (__) => /* @__PURE__ */ jsx(Fragment, {})
  }
});
const htmlAttributesDecorator = {
  rule: (node) => node.type === Node_Type.EXTERNAL,
  decorate: ({ node }) => {
    if (node.textData?.text == null) {
      return /* @__PURE__ */ jsx(Fragment, {});
    }
    const props = Object.fromEntries(
      Object.entries(node.externalData?.fields ?? []).map(([k, v]) => [
        k,
        v.stringValue
      ])
    );
    return /* @__PURE__ */ jsx("span", { ...props, children: node.textData?.text });
  }
};
export {
  htmlAttributesPlugin
};
//# sourceMappingURL=ricos-html-attributes-plugin.js.map
